var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferSavedColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83527 4.78125C5.83527 4.50511 6.05912 4.28125 6.33527 4.28125H13.6647C13.9409 4.28125 14.1647 4.50511 14.1647 4.78125V15.2157C14.1647 15.6719 13.6041 15.8898 13.296 15.5534L11.1062 13.1624C10.5116 12.5131 9.48838 12.5131 8.89381 13.1624L6.704 15.5534C6.39594 15.8898 5.83527 15.6719 5.83527 15.2157V4.78125ZM6.33527 3.28125C5.50684 3.28125 4.83527 3.95282 4.83527 4.78125V15.2157C4.83527 16.5841 6.51729 17.2379 7.44146 16.2288L9.63127 13.8378C9.82946 13.6213 10.1705 13.6213 10.3687 13.8378L12.5585 16.2288C13.4827 17.2379 15.1647 16.5841 15.1647 15.2157V4.78125C15.1647 3.95282 14.4932 3.28125 13.6647 3.28125H6.33527ZM12.7759 7.02555C12.91 6.78416 12.823 6.47976 12.5816 6.34565C12.3402 6.21155 12.0358 6.29852 11.9017 6.53991L9.99426 9.9733L8.68384 8.70967C8.48506 8.51799 8.16853 8.52375 7.97685 8.72253C7.78517 8.92131 7.79092 9.23784 7.9897 9.42952L9.30013 10.6931C9.77294 11.1491 10.5494 11.0331 10.8684 10.4589L12.7759 7.02555Z",
    fill: "url(#paint0_linear_6098_22122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6098_22122",
    x1: 5.33549,
    y1: 2.28073,
    x2: 15.341,
    y2: 16.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128760"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSavedColored);
export default __webpack_public_path__ + "static/media/offer-saved-colored.0a61b5174def58bd9aa2ded3c7f16f44.svg";
export { ForwardRef as ReactComponent };